import { AccredibleIconComponentModule } from '@accredible-frontend-v2/components/icon';
import { AccredibleIconType, CredentialVerificationLevel } from '@accredible-frontend-v2/models';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'rp-credential-verification-level',
  standalone: true,
  imports: [TranslocoDirective, AccredibleIconComponentModule, MatTooltipModule],
  templateUrl: './credential-verification-level.component.html',
  styleUrl: './credential-verification-level.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CredentialVerificationLevelComponent {
  verificationLevel = input.required<CredentialVerificationLevel>();

  private readonly iconMap = {
    verified: 'confidence-level-high',
    unsupported: 'confidence-level-med',
    unverified: 'confidence-level-low',
  };

  icon = computed(() => {
    return {
      type: AccredibleIconType.NEW_ACC,
      name: this.iconMap[this.verificationLevel()],
    };
  });
}
